import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import CustomOptionDropdown from "components/dropdowns/reactselect/CustomOptionDropdown";

interface Props extends FreefieldInputProps {
  dropdownOptions: server.dto.DropdownOption[]
}

const makeSelectionOption: server.dto.DropdownOption = { key: "", value: RESX.Buttons.btnMakeSelection };

const FreefieldDropdown = (props: Props) => {
  const [selected, setSelected] = React.useState<string | null>(props.initialValue);

  const options = [makeSelectionOption, ...props.dropdownOptions];

  const selectedValue = selected == null
    ? null
    : props.dropdownOptions.find(option => option.key === selected) ?? { key: selected, value: selected };

  const onChange = (selectedOption: server.dto.DropdownOption) => {
    if (selectedOption.key === makeSelectionOption.key) {
      setSelected(null);
      props.onChange(null);
    } else {
      setSelected(selectedOption.key);
      props.onChange(selectedOption.key);
    }
  };

  return <CustomOptionDropdown
    excludeKeys={[]}
    value={selectedValue}
    onChange={onChange}
    options={options}
    config={{
      isSearchable: false,
      shouldRenderSelectedValue: true,
      placeholder: RESX.Buttons.btnMakeSelection
    }}
  />;
};

export default FreefieldDropdown;
